import useResponsive from "@/hooks/use-responsive"

export const LockPageLayout = ({ children }: { children: React.ReactNode }) => {
  const { isMobile, isTablet, isDesktop, width } = useResponsive()

  if (isDesktop && width > 1400) {
    return (
      <div className="grid w-full grid-cols-1 gap-4 text-t100 xl:grid-cols-[minmax(auto,720px)_1fr]">
        <div className="flex w-full min-w-[320px] flex-col gap-4">{children}</div>
        <div className="flex max-w-xl flex-col gap-4">{/* <div className="h-[420px] w-full bg-p200"></div> */}</div>
      </div>
    )
  }

  if (isDesktop) {
    return (
      <div className="grid grid-cols-[minmax(auto,720px)_1fr] gap-4">
        <div className="flex flex-col gap-4">{children}</div>
        <div className="flex flex-col gap-4">
          {/* second column here */}
          {/* <div className="h-[420px] w-full bg-p200"></div> */}
        </div>
      </div>
    )
  }

  if (isMobile || isTablet) {
    return (
      <div className="w-full text-t100">
        <div className="space-y-4">{children}</div>
      </div>
    )
  }

  return null
}
